The free-text label of the phase.

Provide a name or description, e.g. `Interview`.
